export const searchButtonAriaLabel = "hpqLid";
export default {searchButtonAriaLabel};